import {createSlice} from "@reduxjs/toolkit";
import {
  ContainerStatusFilterFormValues,
  DataGridPageState,
  DEFAULT_CONTAINER_STATUS_FILTER
} from "@ots-frontend/ots-ui";
import {
  setContainerStatusShutInPageFilter,
  setContainerStatusShutInPageState,
  setContainerStatusShutInPageStateCell,
  setContainerStatusShutInPageStateSort,
  setContainerStatusShutInPageStateWidths
} from "./actions";

export const CONTAINER_STATUS_SHUT_IN_PAGE_WIDTHS_KEY = "containerStatusShutInPageWidthsV3";

const savedContainerStatusPageWidths = localStorage.getItem(CONTAINER_STATUS_SHUT_IN_PAGE_WIDTHS_KEY)

type State = {
  filter: ContainerStatusFilterFormValues
  state: DataGridPageState
}

const INITIAL_STATE: Readonly<State> = {
  filter: DEFAULT_CONTAINER_STATUS_FILTER,
  state: {
    cell: undefined,
    widths: savedContainerStatusPageWidths ? JSON.parse(savedContainerStatusPageWidths) : [],
  }
};

const containerStatusShutInPageSlice = createSlice({
  name: "ui/container-status-shut-in-page",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setContainerStatusShutInPageFilter,
      (state, {payload}) => {
        state.filter = payload
      }
    );
    builder.addCase(
      setContainerStatusShutInPageState,
      (state, {payload}) => {
        state.state = payload
      }
    );
    builder.addCase(
      setContainerStatusShutInPageStateCell,
      (state, {payload}) => {
        state.state.cell = payload
      }
    );
    builder.addCase(
      setContainerStatusShutInPageStateWidths,
      (state, {payload}) => {
        state.state.widths = payload
      }
    );
    builder.addCase(
      setContainerStatusShutInPageStateSort,
      (state, {payload}) => {
        state.state.sort = payload
      }
    );
  }
});

export const containerStatusShutInPageReducer = containerStatusShutInPageSlice.reducer;
